import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="h-12 w-12 text-ruby" />
      <h1 className="mt-6 font-display text-3xl sm:text-4xl">{t("cancel.title")}</h1>
      <p className="mt-3 text-slate-400">{t("cancel.sub")}</p>
      <Link to="/cart" className="btn-gold mt-8" data-testid="cancel-back-btn">{t("cancel.back")}</Link>
    </div>
  );
}
